import React, { useState } from "react";
import { JhButton } from "designPackages/buttonPackage";
import { useSelector } from "react-redux";
import { submitJobPostV2 } from "../JobPostingv2/utils";

type RenderView = (
  onClick: (event: React.MouseEvent<HTMLElement>) => void
) => JSX.Element;

type JobPlan = "PREMIUM" | "BASIC";

interface PostJobViewV2Props {
  children?: React.ReactNode;
  renderView?: RenderView;
  jobPlan: JobPlan;
  errorCallback?: (error: any) => void;
  successCallback?: (response: object) => void;
  classes?: string;
  allowDuplicate?: boolean;
  isAutoJobPosted?: boolean;
  
}

const PostJobViewV2 = ({
  renderView,
  children,
  jobPlan,
  errorCallback,
  successCallback,
  classes,
  allowDuplicate = false,
  isAutoJobPosted = false
}: PostJobViewV2Props) => {
  const [loading, setLoading] = useState(false);

  const userProfile =
    useSelector((state: any) => state.userProfileReducer.payload?.data) || {};
  const onJobPost = async (e: React.MouseEvent<HTMLElement>) => {
    setLoading(true);
    
    try {
      // Use the reusable job posting function
      const response = await submitJobPostV2(jobPlan, {
        userProfile,
        allowDuplicate,
        isAutoJobPosted,
        successCallback,
        errorCallback,
        postJobNow:true
      });

      return response;
      
    } catch (error) {
      console.error('Job posting error:', error);
      
      // Execute external error callback
      if (errorCallback) {
        errorCallback(error);
      }
      
      throw error;
    } finally {
      setLoading(false);
    }
  };

  if (renderView) {
    return renderView(onJobPost);
  }

  return (
    <JhButton className={classes} onClick={onJobPost} disabled={loading}>
      {children}
    </JhButton>
  );
};

export default PostJobViewV2; 